<script>
  import { createEventDispatcher, onMount, tick } from "svelte";
  import FormValidate from "./FormValidate.svelte";
  import Closer from "./base/Closer.svelte";
  import TelField from "./base/TelField.svelte";
  import Button from "./base/Button.svelte";
  import {
    toArray,
    getWrittenName,
    splitNameAndPrice,
    fetchLocation,
    checkIfSomeItemCloseConversation,
    addHttpsToUrl,
    ensureUrlFieldPrefix,
    normalizeUrlFieldValue,
    checkZipCodeExclusions,
    checkPhoneAreaCodeExclusions,
    interpolatePageVariables,
    getAutocomplete,
  } from "../utils/utilities";
  import Spinner from "./base/Spinner.svelte";
  import { fileUpload, getHost } from "../utils/sendwhatsapp_rewrite_chabi";
  import { isClosedConversationStore } from "../store";
  import Toast from "./base/Toast.svelte";
  import { currentLanguage } from "../store";
  import translations from "../translations";
  import { getFormFromLocalStorage, saveFormToLocalStorage } from "../utils/localStorage";
  import flatpickr from "flatpickr";
  import { Spanish } from "flatpickr/dist/l10n/es.js";
  import { French } from "flatpickr/dist/l10n/fr.js";
  import { Italian } from "flatpickr/dist/l10n/it.js";
  import { German } from "flatpickr/dist/l10n/de.js";
  import { Polish } from "flatpickr/dist/l10n/pl.js";
  import { Hindi } from "flatpickr/dist/l10n/hi.js";
  import { Malay } from "flatpickr/dist/l10n/ms.js";
  import confirmDatePlugin from "flatpickr/dist/plugins/confirmDate/confirmDate.js";
  import SearchableSelect from "./base/SearchableSelect.svelte";
  import { getAdvancedBookingTimes, getFullDayCategories, getFullDayEvents } from "../utils/getdata";
  import BookingsAdvancedCalendar from "./bookingsAdvanced/BookingsAdvancedCalendar.svelte";
  import SelectAsButtons from "./base/SelectAsButtons.svelte";
  import MultiSelect from "./base/MultiSelect.svelte";
  import PriceLines from "./base/PriceLines.svelte";
  import NativePickerInput from "./base/NativePickerInput.svelte";

  const dispatch = createEventDispatcher();

  // --- Form and state variables ---
  let errorList = [];
  let formValidateList = [];
  let showBooking = false;
  let isLoading = false;
  let isValidatingEmail = false;
  let cookieModalExist = eval("typeof modalPrivacityTermsCookies") === "function";
  let currentLang = "en";
  let filteredNumber;
  let inputElements = [];
  let disabledDates = [];
  let enabledCategories = [];
  let flatPickerInstances = [];
  let showBookingsAdvancedScreen = false;
  let bookingsAdvancedRequiredError = false;
  let selectedBookingAdvancedCategoryIds = [];
  let showCloseConversationToast = false;
  let currentStep = 0;
  $: fieldSteps = formitems.items.reduce((steps, item, i) => {
    steps.push((i ? steps[i - 1] : 0) + (item.type === "step" ? 1 : 0));
    return steps;
  }, []);
  $: visibleSteps = [...new Set(formitems.items.map((item, i) =>
    item.type !== "step" && !["hidden", "hidden2", "metaTag"].includes(item.type) && !filtered[i] && !(item.onlyAdmins && !data.showAdminFields) ? fieldSteps[i] : null
  ).filter(step => step !== null))];
  $: if (visibleSteps.length && !visibleSteps.includes(currentStep)) currentStep = visibleSteps.find(step => step > currentStep) ?? visibleSteps[visibleSteps.length - 1];
  $: showStepNavigation = visibleSteps.length > 1 && !showBooking && !showBookingsAdvancedScreen;
  $: hasNextStep = visibleSteps.indexOf(currentStep) < visibleSteps.length - 1;
  $: hasPreviousStep = visibleSteps.indexOf(currentStep) > 0;
  const revealError = async (index) => {
    currentStep = fieldSteps[index];
    await tick();
    scrollToFormElement(document.getElementById(formitems.items[index]?.id));
  };
  let reSendEmail = false;
  let reSendWhatsapp = false;

  export let formitems;
  export let data;
  export let noclose = false;
  export let person;
  export let isBigperson = false;

  $: isCloseConversationMessage = formitems.items.some((item) => {
    const val = item.val ?? item.selectVal;
    const domain = val?.split?.("@")[1]?.split?.(".")[0];

    const closeInSelect = item.dataObject?.some((obj) => obj.value === val && obj.closeConversation && obj.closeConversationMessage === sendMessage);

    const closeInEmail =
      item.type === "email" && item.filterDomain && (domain === "gmail" || domain === "hotmail") && item.closeConversationMessage === sendMessage;

    const closeInZip = item.type === "zipcode" && checkZipCodeExclusions(item) === sendMessage;

    const closeInPhone = item.type === "tel" && checkPhoneAreaCodeExclusions(item) === sendMessage;

    return closeInSelect || closeInEmail || closeInZip || closeInPhone;
  });

  $: fullScreenMobile = data.expandFullScreenMobile;
  $: notQualified = false;
  $: isSent = false;
  $: sendMessage = data.transSuccessMessage ?? translations.sentMessage[currentLang];
  // Observa cambios en item.useCheckAvailability o item.checkCategoriesByDate
  $: {
    formitems.items.forEach((item, i) => {
      if (item.type === "selectBookingFullDay" && inputElements[i]) {
        initializeFlatpickrFullDays(i, item);
      }
    });
  }
  $: totalPrice = calculateTotalPrice();
  $: totalDuration = calculateTotalDuration();

  let isClosedConversation = false;

  let filtered = formitems.items.map((item) => item.fieldToFilterFrom);
  filteredNumber = filtered.filter((item) => item).length;
  formitems.items
    .filter((item) => item.type !== "freetext")
    .forEach((a) => {
      if (a.val === undefined || a.val === null) {
        a.val = "";
      }
    });

  onMount(() => {
    // Subscribe to changes in currentLanguage
    currentLanguage.subscribe((value) => {
      currentLang = value;
    });

    // Initialize flatpickr for date and time inputs
    let selectBookingAlreadyDisplayed = false;
    formitems.items.forEach((item, i) => {
      if (item.type === "selectBooking") {
        selectBookingAlreadyDisplayed ? (item.displayDateSelect = false) : (item.displayDateSelect = true);
        flatPickerInstances[i] = flatpickr(inputElements[i], {
          enableTime: true,
          dateFormat: "d/m/Y, H:i",
          minDate: "today",
          time_24hr: true,
          locale: getFlatpickrLocale(currentLang),
          disableMobile: true,
          plugins: [
            new confirmDatePlugin({
              confirmIcon: "",
              confirmText: translations.confirm[currentLang],
              showAlways: false,
            }),
          ],
          onChange: (selectedDates) => {
            let date = new Date(selectedDates[0]);
            let timeZonedDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
            item.dateVal = timeZonedDate.toISOString().slice(0, 16);
          },
        });
        selectBookingAlreadyDisplayed = true;
      } else if (item.type === "selectBookingFullDay") {
        initializeFlatpickrFullDays(i, item);
        enabledCategories = toArray(item.data);
      } else if (
        (item.type === "selectAndPrice" || item.type === "selectBookingAdvanced") &&
        item.canMultiply &&
        (item.amount === undefined || item.amount === null || item.amount === "")
      ) {
        item.amount = 1;
      }
    });

    // Preserve values set programmatically on hidden2 fields (e.g. via external scripts).
    // Svelte's bind:value resets the DOM on re-renders; overriding the setter prevents that
    // while keeping item.value in sync so the existing submit logic works unchanged.
    const valueDescriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value");
    formitems.items.forEach((item) => {
      if (item.type !== "hidden2") return;
      const el = document.getElementById(item.id);
      if (!el) return;
      Object.defineProperty(el, "value", {
        get: function () { return valueDescriptor.get.call(this); },
        set: function (newVal) {
          if ((newVal === "" || newVal == null) && valueDescriptor.get.call(this)) return;
          valueDescriptor.set.call(this, newVal);
          if (newVal !== "" && newVal != null) item.value = newVal;
        },
        configurable: true,
      });
    });
  });

  if (person?.bookingConfigs?.length > 0 && isBigperson) {
    showBooking = true;
  }

  // Function to get the Flatpickr locale
  function getFlatpickrLocale(currentLang) {
    switch (currentLang) {
      case "fr":
        return French;
      case "it":
        return Italian;
      case "de":
        return German;
      case "pl":
        return Polish;
      case "hi":
        return Hindi;
      case "ms":
        return Malay;
      case "es":
        return Spanish;
      default:
        return undefined; // By default it uses English
    }
  }

  async function initializeFlatpickrFullDays(index, item) {
    await tick();
    if (!inputElements[index]) return;

    flatPickerInstances[index] = flatpickr(inputElements[index], {
      mode: "range",
      dateFormat: "d/m/Y",
      minDate: "today",
      locale: getFlatpickrLocale(currentLang),
      disableMobile: true,
      disable: [],
      plugins: [
        new confirmDatePlugin({
          confirmIcon: "",
          confirmText: translations.confirm[currentLang],
          showAlways: false,
        }),
      ],
      onChange: (selectedDates, dateStr, instance) => {
        if (selectedDates.length === 2) {
          let startDate = new Date(selectedDates[0]);
          let endDate = new Date(selectedDates[1]);
          let timeZonedStartDate = new Date(startDate.getTime() - startDate.getTimezoneOffset() * 60000);
          let timeZonedEndDate = new Date(endDate.getTime() - endDate.getTimezoneOffset() * 60000);
          item.startDateVal = timeZonedStartDate.toISOString().slice(0, 10);
          item.endDateVal = timeZonedEndDate.toISOString().slice(0, 10);

          if (item.useCheckAvailability) getEnabledCategories(item.startDateVal, item.endDateVal);

          if (formitems.showTotal) {
            totalPrice = calculateTotalPrice();
          }
        }
      },
    });
  }

  const handleFileSelected = (e, i) => {
    formitems.items[i].val = e.target.files[0];
  };

  // function to check if the zip code is valid and fetch the location data
  const handlePostalCodeBlur = async (postalCode) => {
    const locationData = await fetchLocation(postalCode, data.country);

    if (locationData) {
      const { city, province } = locationData;

      // create or update the city field
      let cityField = formitems.items.find((item) => item.label === "City");
      if (!cityField) {
        cityField = { label: "City", value: city, type: "hidden", required: false };
        formitems.items.push(cityField);
      } else {
        cityField.value = city;
      }

      // create or update the province field
      let provinceField = formitems.items.find((item) => item.label === "Province");
      if (!provinceField) {
        provinceField = { label: "Province", value: province, type: "hidden", required: false };
        formitems.items.push(provinceField);
      } else {
        provinceField.value = province;
      }

      await tick(); // Prevents a Svelte warning about updating the DOM during rendering
    }
  };

  const sendtocallme = async (url = null) => {
    if (isLoading || isValidatingEmail) {
      return;
    }
    if (showBooking) {
      dispatch("booking");
      return;
    }

    const advancing = hasNextStep && !showBookingsAdvancedScreen;
    const shouldValidate = (i) => formitems.items[i]?.type !== "step" && !filtered[i] &&
      !(formitems.items[i]?.onlyAdmins && !data.showAdminFields) && (!advancing || fieldSteps[i] === currentStep);
    // Validators share this array through bind:value. Keep its reference so
    // synchronous validation writes into the same list checked before sending.
    errorList.splice(0, errorList.length, ...errorList.filter(error => shouldValidate(error.index)));
    for (let i in formValidateList) {
      if (!shouldValidate(i)) continue;
      try {
        formValidateList[i].validate();
      } catch (ex) {
        //console.log(ex);
      }
    }

    if (errorList.length > 0) {
      tick().then(() => {
        const firstErrorIndex = errorList.reduce((min, e) => (e.index < min ? e.index : min), errorList[0].index);
        revealError(Number(firstErrorIndex));
      });
      return;
    }

    if (errorList.length == 0) {
      let hasServerValidationError = false;
      for (let i = 0; i < formitems.items.length; i++) {
        const fItem = formitems.items[i];
        if (shouldValidate(i) && fItem.type === "email" && fItem.serverValidation === true && fItem.val && fItem.val !== "" && !filtered[i] && formValidateList[i]) {
          try {
            isValidatingEmail = true;
            const res = await fetch(`${getHost()}/api/widget/${data.id}/email/validate?email=${encodeURIComponent(fItem.val)}`);
            const result = await res.json();
            if (result.valid === false) {
              formValidateList[i].setServerError(result.message || (data.emailValidationText ?? translations.emailValidationText[currentLang]));
              hasServerValidationError = true;
            }
          } catch (e) {
            // If server unreachable, don't block submission
          } finally {
            isValidatingEmail = false;
          }
        }
      }
      if (hasServerValidationError) {
        await revealError(Number(errorList[0].index));
        return;
      }
      if (advancing) {
        currentStep = visibleSteps[visibleSteps.indexOf(currentStep) + 1];
        return;
      }

      for (let i in formitems.items) {
        if (formitems.items[i].type === "url") {
          formitems.items[i].val = normalizeUrlFieldValue(formitems.items[i].val);
        }
        if (formitems.items[i].type === "file" && formitems.items[i].val instanceof File && !filtered[i]) {
          isLoading = true;
          const res = await fileUpload(formitems.items[i].val, person.id);
          formitems.items[i].val = res?.data?.id;
        } else if (formitems.items[i].type === "file" && typeof formitems.items[i].val === "string") {
          const parts = formitems.items[i].val.split("/file-user/");
          if (parts.length > 1) formitems.items[i].val = parts[1];
        }
        if (formitems.items[i].type === "hidden") {
          formitems.items[i].val = formitems.items[i].value ?? formitems.items[i].hval;
        }
        if (formitems.items[i].type === "hidden2") {
          formitems.items[i].val = formitems.items[i].value ?? formitems.items[i].hval;
        }
        if (formitems.items[i].type === "metaTag") {
          const metaValue = getMetaTagContent(formitems.items[i].hval || formitems.items[i].value);
          formitems.items[i].val = metaValue ?? "";
        }
        if (formitems.items[i].type === "selectBooking") {
          formitems.items[i].val = formitems.items[i].selectVal;
        }
        if (formitems.items[i].type === "selectBookingFullDay") {
          formitems.items[i].val = formitems.items[i].selectVal;
        }
        if (formitems.items[i].type === "selectBookingAdvanced") {
          formitems.items[i].val = formitems.items[i].selectVal;
        }
      }
      isLoading = false;
      let scoreCnt = 0,
        scoreSum = 0,
        score;
      if (person.form.activateScoringFilter) {
        for (let item of formitems.items) {
          if (item.type === "select") {
            score = item.dataObject.find((obj) => obj.value === item.val)?.score;
            switch (score) {
              case "gold":
                scoreSum += 3;
                break;
              case "silver":
                scoreSum += 2;
                break;
              case "bronze":
                scoreSum += 1;
                break;
            }
            scoreCnt++;
          }
        }
      }

      // update selectedBookingAdvancedCategoryIds
      selectedBookingAdvancedCategoryIds = getAdvancedBookingCategories();

      // save form data to local storage for prefilling
      if (data.saveDataInWidget) {
        let formData = formitems.items.filter((item, i) => item.type !== "freetext" && item.type !== "step" && !filtered[i]);
        saveFormToLocalStorage(data.id, formData);
      }

      notQualified =
        (scoreCnt > 0 && scoreSum / scoreCnt < 2) ||
        (person.online === false && data.offlineLeads === true) ||
        (data.desktopLeads === true && window.innerWidth > 1000);

      // if there is a bookingsAdvance item and it is not shown yet, show it. Else, validate and continue sending the form
      let bookingsAdvancedItem = formitems.items.find((item) => item.type === "selectBookingAdvanced");
      if (bookingsAdvancedItem && !showBookingsAdvancedScreen) {
        if (!bookingsAdvancedItem.selectVal) return;

        const preselectedApplied = await applyPreselectedAdvancedBooking(bookingsAdvancedItem);
        if (!preselectedApplied) {
          showBookingsAdvancedScreen = true;
          return;
        }
      } else if (bookingsAdvancedItem && showBookingsAdvancedScreen) {
        if (!bookingsAdvancedItem.dateVal || !bookingsAdvancedItem.timeVal) {
          bookingsAdvancedRequiredError = true;
          return;
        } else {
          bookingsAdvancedRequiredError = false;
        }
      }

      dispatch("callmex", {
        data: formitems.items.filter((item, i) => item.type !== "freetext" && item.type !== "step" && !filtered[i]),
        url: url,
        notQualified: notQualified,
        reSendEmail: data.editModeStatId && data.showAdminFields ? reSendEmail : false,
        reSendWhatsapp: data.editModeStatId && data.showAdminFields ? reSendWhatsapp : false,
      });

      if (!checkIfSomeItemCloseConversation(formitems.items)) {
        sendMessage = data.transSuccessMessage ?? translations.sentMessage[currentLang];
      }

      showCloseConversationToast = isCloseConversationMessage;
      isSent = true;

      if (!showCloseConversationToast) {
        setTimeout(() => {
          isSent = false;
        }, 3500);
      }

      if (!data.editModeStatId) {
        clearForm();
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.code == "Enter") {
      event.preventDefault();
    }
  };

  const emitFieldClickEvent = (item) => {
    if (typeof window.dataLayer === "object") {
      window.dataLayer.push({
        event: "cw_form_field_click",
        cw_field_id: item.id,
        cw_field_label: item.label,
        cw_field_type: item.type,
      });
    }
    if (typeof window !== "undefined" && window.parent) {
      window.parent.postMessage(
        { type: "form-field-click", field: { id: item.id, label: item.label, type: item.type } },
        "*"
      );
    }
  };

  const handleBlur = async (event, index) => {
    if (isClosedConversation) {
      return;
    }
    if (event.code == "Enter") {
      event.preventDefault();
    }
    formitems.items.forEach((item, i) => {
      checkFilter(i);
    });

    if (formitems.showTotal) {
      totalPrice = calculateTotalPrice();
    }

    if (formitems.showTotalDuration) {
      totalDuration = calculateTotalDuration();
    }

    if (formitems.items[index].type === "selectBookingFullDay" && formitems.items[index].useCheckAvailability) {
      if (!formitems.items[index].checkCategoriesByDate) {
        await getDisabledDates(index);
      }
    }

    // if field type is selectAndPrice or selectBookingAdvanced, check min and max amount
    if (
      (formitems.items[index].type === "selectAndPrice" || formitems.items[index].type === "selectBookingAdvanced") &&
      formitems.items[index].canMultiply
    ) {
      checkMinAndMaxAmount(formitems.items[index]);
    }

    // Si el campo es de tipo "zipcode", llama a handlePostalCodeBlur
    if (formitems.items[index].type === "zipcode") {
      await handlePostalCodeBlur(formitems.items[index].val);
      sendMessage = checkZipCodeExclusions(formitems.items[index]) ?? sendMessage;
    }

    if (formitems.items[index].type === "tel") {
      sendMessage = checkPhoneAreaCodeExclusions(formitems.items[index]) ?? sendMessage;
    }

    if (formitems.items[index].type === "select" || formitems.items[index].type === "selectAndPrice") {
      const option = formitems.items[index].dataObject.find((obj) => obj.value === formitems.items[index].val);
      if (option?.closeConversation) {
        sendMessage = option.closeConversationMessage;
      }
    }

    if (formitems.items[index].type === "email" && formitems.items[index].filterDomain) {
      // check if is gmail or hotmail
      let domain = formitems.items[index].val.split("@")[1];
      domain = domain?.split(".")[0];
      if (domain === "gmail" || domain === "hotmail") {
        sendMessage = formitems.items[index].closeConversationMessage;
      }
    }
    checkNewVisibleFields(formitems.items[index]);
    await tick();
    formValidateList[index]?.validate?.();
  };

  const handleUrlFocus = (event, item) => {
    const value = ensureUrlFieldPrefix(item.val);
    item.val = value;
    event.currentTarget.value = value;
    emitFieldClickEvent(item);
  };

  const handleUrlKeyup = (event, index) => {
    if (event.key === "Tab" || event.code === "Tab") return;
    handleBlur(event, index);
  };

  const checkFilter = (index) => {
    if (index < 0) {
      return false;
    }
    const item = formitems.items[index];
    if (!item.fieldToFilterFrom) {
      return false;
    }
    const values = item.valueToFilterFrom.split("|");

    const checkItem = formitems.items[item.fieldToFilterFrom - 1];
    let isMatch = true;
    if (filtered[item.fieldToFilterFrom - 1] !== true) {
      values.forEach((value) => {
        if (checkItem.type === "checkbox") {
          if (checkItem.val === (value === 1 || value === "1")) {
            isMatch = false;
          }
        } else if (checkItem.type === "selectBookingFullDay") {
          if (value?.trim() === checkItem.selectVal?.trim()) {
            isMatch = false;
          }
        } else if (checkItem.type === "selectBookingAdvanced") {
          if (value.trim() === checkItem.selectVal.trim()) {
            isMatch = false;
          }
        } else {
          let isPreffix = value.endsWith("*");
          if (isPreffix) {
            // remove the * from the value
            let preffix = value.slice(0, -1);
            // check if the value starts with the preffix
            if (checkItem.val.startsWith(preffix)) {
              isMatch = false;
            }
          } else {
            if (value.trim() === checkItem.val.trim()) {
              isMatch = false;
            }
          }
        }
      });
    }

    filtered[index] = isMatch;
    return isMatch;
  };

  const clearForm = () => {
    formitems.items.forEach((item) => {
      item.val = "";
      if (item.type === "price") item.priceLines = [{ legend: "", price: "" }];
      item.type === "tel" && (item.telNum = "");
    });
  };

  const prefillForm = (formId) => {
    if (data.saveDataInWidget) {
      const savedData = getFormFromLocalStorage(formId);
      if (savedData) {
        formitems.items.forEach((item, i) => {
          const savedItem = savedData.find((saved) => saved.id === item.id);
          if (savedItem) {
            item.val = savedItem.val;
            if (item.type === "price" && Array.isArray(savedItem.priceLines)) item.priceLines = savedItem.priceLines;
            if (item.type === "tel") {
              item.telNum = savedItem.telNum;
              item.telCode = savedItem.telCode;
            }
            if (item.type === "zipcode") {
              handlePostalCodeBlur(savedItem.val);
            }
          }
        });
      }
    }
  };

  prefillForm(data.id);

  async function selectOption(data, item, element) {
    await tick();

    if ((item.type === "selectAndPrice" || item.type === "selectBookingAdvanced") && item.canMultiply) {
      checkMinAndMaxAmount(item);
    }

    // check if has to close the conversation
    const option = item.dataObject.find((obj) => obj.value === item.val);
    if (option?.closeConversation) {
      sendMessage = option.closeConversationMessage;
    }

    formitems.items.forEach((_, i) => {
      checkFilter(i);
    });

    checkNewVisibleFields(item);

    if (formitems.showTotal) {
      totalPrice = calculateTotalPrice();
    }
    if (formitems.showTotalDuration) {
      totalDuration = calculateTotalDuration();
    }
  }

  async function unselectOption(data, item, element) {
    await tick();

    if ((item.type === "selectAndPrice" || item.type === "selectBookingAdvanced") && item.canMultiply) {
      item.amount = 1;
      item.minAmount = undefined;
      item.maxAmount = undefined;
    }

    formitems.items.forEach((_, i) => {
      checkFilter(i);
    });

    checkNewVisibleFields(item);
  }

  function isOptionSelected(val, option, multiple) {
    if (multiple) {
      const values = typeof val === "string" ? val.split("|||") : [];
      return values.includes(String(option));
    }
    return String(val) === String(option);
  }

  function toggleMultiOption(item, option) {
    const current = typeof item.val === "string" ? item.val.split("|||") : [];
    if (current.includes(option)) {
      item.val = current.filter((v) => v !== option).join("|||");
    } else {
      item.val = [...current, option].join("|||");
    }
  }

  function replaceURLsWithLinks(text) {
    // Regular expression to match URLs outside of <a> tags
    const urlRegex = /(?<!<a\s+[^>]*?href=["'])https?:\/\/[^\s<]+(?![^<]*<\/a>)/g;

    // Replace URLs outside of <a> tags with <a> tags
    return text.replace(urlRegex, (url) => {
      return `<br/><br/><b><a href="${url}" target="_blank">${url}</a></b><br/><br/>`;
    });
  }

  function scrollToFormElement(element) {
    if (!element) return;
    const container = document.getElementsByClassName("chatwith-form-wrapper")[0];
    if (!container) return;
    const containerRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    container.scrollTo({
      top: container.scrollTop + elementRect.top - containerRect.top - containerRect.height / 3,
      behavior: "smooth",
    });
  }

  function scrollToNext(item) {
    tick().then(() => {
      let nextIndex = formitems.items.findIndex((i) => i.id === item.id) + 1;
      let nextElement = document.getElementById(formitems.items[nextIndex]?.id);
      scrollToFormElement(nextElement);
    });
  }

  function checkNewVisibleFields(item) {
    if (filtered.filter((i) => i).length < filteredNumber) {
      // if there are new visible fields, scroll to next item to make sure the user sees them
      scrollToNext(item);
    }
    // update the number of visible fields
    filteredNumber = filtered.filter((item) => item).length;
  }

  async function getDisabledDates(index) {
    let category = formitems.items[index].dataObject.find((obj) => obj.value === formitems.items[index].selectVal);
    let datesToDisable = await getFullDayEvents(person.id, category?.id);
    if (!datesToDisable) {
      flatPickerInstances[index].set("disable", []);
      return;
    }
    datesToDisable = datesToDisable.map((event) => {
      let from = event.agreedStartTime.date.split(" ")[0];
      //reverse the date format
      from = from.split("-").reverse().join("-");
      let to = event.agreedStopTime.date.split(" ")[0];
      //reverse the date format
      to = to.split("-").reverse().join("-");
      return {
        from: from,
        to: to,
      };
    });
    disabledDates = datesToDisable;

    flatPickerInstances[index].set("disable", disabledDates);
  }

  async function getEnabledCategories(fromDate, toDate) {
    enabledCategories = await getFullDayCategories(person.id, fromDate, toDate);
    enabledCategories = enabledCategories.map((category) => category.code);
  }

  function checkMinAndMaxAmount(item) {
    let selectedOption = item.dataObject.find((option) => option.value === (item.type === "selectBookingAdvanced" ? item.selectVal : item.val));

    if (selectedOption) {
      item.minAmount = selectedOption.canMultiplyMin;
      item.maxAmount = selectedOption.canMultiplyMax;
    }
  }

  function handleBookingSelected(event) {
    let bookingsAdvancedItem = formitems.items.find((item) => item.type === "selectBookingAdvanced");
    if (bookingsAdvancedItem) {
      bookingsAdvancedItem.dateVal = event.detail.time.slice(0, 16);
      bookingsAdvancedItem.timeVal = event.detail.time;
    }
  }

  async function applyPreselectedAdvancedBooking(item) {
    const date = data.preselectedBookingDate;
    const time = String(data.preselectedBookingTime || "").slice(0, 5);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date || "") || !/^\d{2}:\d{2}$/.test(time)) return false;

    const categoryIds = getAdvancedBookingCategories();
    if (categoryIds.length === 0) return false;

    try {
      const slots = await getAdvancedBookingTimes(categoryIds, date);
      const selectedSlot = slots.find((slot) => {
        const slotTime = String(slot?.time || "");
        return slotTime.slice(0, 10) === date && slotTime.slice(11, 16) === time;
      });
      if (!selectedSlot) return false;

      item.dateVal = String(selectedSlot.time).slice(0, 16);
      item.timeVal = selectedSlot.time;
      return true;
    } catch (_) {
      return false;
    }
  }

  function calculateTotalPrice() {
    let total = 0;
    let filteredItems = formitems.items.filter((item, i) => !filtered[i]);
    for (const item of filteredItems) {
      // For "selectAndPrice"
      if (item.type === "selectAndPrice") {
        if (item.val) {
          const option = item.dataObject && item.dataObject.find((opt) => opt.value === item.val);
          if (option) {
            const numericPrice = parseFloat(option.price) || 0;
            // If canmultiply, use item.amount; otherwise, use the price as is
            const amount = item.canMultiply ? parseFloat(item.amount) || 1 : 1;
            total += numericPrice * amount;
          }
        }
      }
      // For "selectBooking"
      else if (item.type === "selectBooking") {
        if (item.selectVal) {
          const option = item.dataObject && item.dataObject.find((opt) => opt.value === item.selectVal);
          if (option) {
            const price = option.price;
            total += parseFloat(price) || 0;
          }
        }
      }
      // For "selectBookingFullDay"
      else if (item.type === "selectBookingFullDay") {
        if (item.selectVal && item.startDateVal && item.endDateVal) {
          const option = item.dataObject && item.dataObject.find((opt) => opt.value === item.selectVal);
          if (option) {
            const numericPrice = parseFloat(option.price) || 0;
            // Calculate the number of days between the start and end dates
            const start = new Date(item.startDateVal);
            const end = new Date(item.endDateVal);
            const diffTime = Math.abs(end - start);
            const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
            total += numericPrice * diffDays;
          }
        }
      }
      // For "selectBookingAdvanced"
      else if (item.type === "selectBookingAdvanced") {
        if (item.selectVal) {
          const option = item.dataObject && item.dataObject.find((opt) => opt.value === item.selectVal);
          if (option) {
            const numericPrice = parseFloat(option.price) || 0;
            // If canmultiply, use item.amount; otherwise, use the price as is
            const amount = item.canMultiply ? parseFloat(item.amount) || 1 : 1;
            total += numericPrice * amount;
          }
        }
      }
      // For "checkbox"
      else if (item.type === "checkbox") {
        if (item.val && item.price) {
          total += parseFloat(item.price) || 0;
        }
      }
      // For "freetext"
      else if (item.type === "freetext") {
        if (item.showPrice && item.price) {
          total += parseFloat(item.price) || 0;
        }
      }
      // For an editable price field, its entered value is part of the total.
      else if (item.type === "price") {
        total += parseFloat(item.val) || 0;
      }
    }
    return total;
  }

  function calculateTotalDuration() {
    let minutes = 0;
    let filteredItems = formitems.items.filter((item, i) => !filtered[i]);
    for (const item of filteredItems) {
      if (item.type === "selectBookingAdvanced") {
        if (item.selectVal) {
          const option = item.dataObject && item.dataObject.find((opt) => opt.value === item.selectVal);
          if (option) {
            const numericDuration = parseFloat(option.duration) || 0;
            minutes += numericDuration * (item.canMultiply ? parseFloat(item.amount) || 1 : 1);
          }
        }
      }
    }

    const formatDuration = (minutes) => {
      const hours = Math.floor(minutes / 60);
      const remainingMinutes = minutes % 60;

      if (hours > 0 && remainingMinutes > 0) {
        return `${hours}h ${remainingMinutes}m`;
      } else if (hours > 0) {
        return `${hours}h`;
      } else {
        return `${remainingMinutes}m`;
      }
    };

    return formatDuration(minutes);
  }

  function getAdvancedBookingCategories() {
    let categoryIds = [];
    formitems.items.forEach((item) => {
      if (item.type === "selectBookingAdvanced") {
        let category = item.dataObject && item.dataObject.find((opt) => opt.value === item.selectVal);
        if (category) {
          categoryIds.push(category.id);
        }
      }
    });
    return categoryIds;
  }

  function getMetaTagContent(rawName) {
    if (typeof document === "undefined" || !rawName) return null;

    // Remove curly braces and trim whitespace
    const name = rawName.replace(/[{}]/g, "").trim();
    if (!name) return null;

    const tag = document.querySelector(`meta[name="${name}"]`);
    return tag ? tag.getAttribute("content") : null;
  }
</script>

<div class:fullScreenMobile class="chatwith-form-wrapper">
  <div class="chatwith-form">
    <div>
      {#if !showBooking && !showBookingsAdvancedScreen}
        {#if formitems.info != ""}
          <div class="textito">{formitems.info}</div>
        {/if}
        {#each formitems.items as item, i}
          <div class:hidden={item.type === "step" || fieldSteps[i] !== currentStep || filtered[i] || (item.onlyAdmins && !data.showAdminFields)} class:admin-only-field={item.onlyAdmins && data.showAdminFields}>
            {#if item.onlyAdmins && data.showAdminFields}
              <span class="admin-only-badge">Admin</span>
            {/if}
            {#if item.type == "text"}
              <div class="form-element">
                {#if item.subtype === "multiline"}
                  <textarea
                    id={item.id}
                    bind:value={item.val}
                    class={item.isError ? "error-border" : ""}
                    placeholder={`${item.label}${item.required ? "*" : ""}`}
                    on:keypress={handleKeyPress}
                    on:keyup={(evt) => handleBlur(evt, i)}
                    on:focus={() => emitFieldClickEvent(item)}
                    rows="4"
                  />
                {:else}
                  <input
                    id={item.id}
                    bind:value={item.val}
                    type="text"
                    autocomplete={getAutocomplete(item)}
                    class={item.isError ? "error-border" : ""}
                    placeholder={`${item.label}${item.required ? "*" : ""}`}
                    on:keypress={handleKeyPress}
                    on:keyup={(evt) => handleBlur(evt, i)}
                    on:focus={() => emitFieldClickEvent(item)}
                  />
                {/if}
              </div>
            {:else if item.type == "file"}
              <div class="form-element">
                <p class="file-label">{item.label}</p>
                {#if typeof item.val === "string" && item.val}
                  <div class="existing-file-preview">
                    <img
                      src="{item.val}"
                      alt="preview"
                      class="file-preview-img"
                      on:error={(e) => { e.target.style.display = 'none'; }}
                    />
                    <div class="file-preview-actions">
                      <a href="{item.val}" target="_blank" rel="noopener noreferrer">
                        Ver archivo adjunto
                      </a>
                      <button type="button" class="replace-file-btn" on:click={() => { item.val = null; }}>
                        Reemplazar
                      </button>
                    </div>
                  </div>
                {:else}
                  <input
                    id={item.id}
                    type="file"
                    class={item.isError ? "error-border" : ""}
                    accept=".pdf, .docx, .xlsx, .jpg, .jpeg, .png, .zip"
                    on:change={(e) => handleFileSelected(e, i)}
                  />
                {/if}
              </div>
            {:else if item.type === "price"}
              <div class="form-element">
                <PriceLines
                  {item}
                  currency={data?.currency}
                  legendPlaceholder={translations.priceLineLegend[currentLang] ?? translations.priceLineLegend.en}
                  pricePlaceholder={translations.priceLinePrice[currentLang] ?? translations.priceLinePrice.en}
                  addLineLabel={translations.addPriceLine[currentLang] || translations.addPriceLine.en}
                  removeLineLabel={translations.removePriceLine[currentLang] || translations.removePriceLine.en}
                  on:change={(evt) => handleBlur(evt, i)}
                  on:focus={() => emitFieldClickEvent(item)}
                />
              </div>
            {:else if item.type === "number"}
              <div class="form-element">
                <input
                  id={item.id}
                  bind:value={item.val}
                  type="number"
                  class={item.isError ? "error-border" : ""}
                  placeholder={`${item.label}${item.required ? " *" : ""}`}
                  min={item.min}
                  max={item.max}
                  on:keypress={handleKeyPress}
                  on:keyup={(evt) => handleBlur(evt, i)}
                  on:focus={() => emitFieldClickEvent(item)}
                />
              </div>
            {:else if item.type == "url"}
              <div class="form-element">
                <input
                  id={item.id}
                  bind:value={item.val}
                  type="url"
                  class={item.isError ? "error-border" : ""}
                  placeholder={`${item.label}${item.required ? " *" : ""}`}
                  on:keypress={handleKeyPress}
                  on:keyup={(evt) => handleUrlKeyup(evt, i)}
                  on:focus={(evt) => handleUrlFocus(evt, item)}
                />
              </div>
            {:else if item.type == "date"}
              <div class="form-element">
                <NativePickerInput
                  id={item.id}
                  bind:value={item.val}
                  type="date"
                  label={item.label}
                  required={item.required}
                  isError={item.isError}
                  on:change={(evt) => handleBlur(evt, i)}
                  on:focus={() => emitFieldClickEvent(item)}
                />
              </div>
            {:else if item.type == "time"}
              <div class="form-element">
                <NativePickerInput
                  id={item.id}
                  bind:value={item.val}
                  type="time"
                  label={item.label}
                  required={item.required}
                  isError={item.isError}
                  on:change={(evt) => handleBlur(evt, i)}
                  on:focus={() => emitFieldClickEvent(item)}
                />
              </div>
            {:else if item.type == "datetime" || item.type == "datetime-local"}
              <div class="form-element">
                <NativePickerInput
                  id={item.id}
                  bind:value={item.val}
                  type="datetime-local"
                  label={item.label}
                  required={item.required}
                  isError={item.isError}
                  on:change={(evt) => handleBlur(evt, i)}
                  on:focus={() => emitFieldClickEvent(item)}
                />
              </div>
            {:else if item.type == "select"}
              <div class="form-element">
                {#if !item.showAsButton && !item.showAsTable}
                  {#if item.usePredictiveText}
                    <SearchableSelect
                      id={item.id}
                      {item}
                      bind:selected={item.val}
                      options={toArray(item.data)}
                      placeholder={item.label}
                      showLabel={false}
                      label={item.label}
                      required={item.required}
                      on:change={(evt) => handleBlur(evt, i)}
                      isError={item.isError}
                    />
                  {:else if item.multiple}
                    <MultiSelect
                      id={item.id}
                      bind:selected={item.val}
                      options={toArray(item.data)}
                      dataObject={item.dataObject}
                      placeholder={item.label}
                      label={item.label}
                      isError={item.isError}
                    />
                  {:else}
                    <div class="chatwith-select">
                      <!-- svelte-ignore a11y-no-onchange -->
                      <select id={item.id} bind:value={item.val} class={item.isError ? "error-border" : ""} on:change={(evt) => handleBlur(evt, i)}>
                        <option value="">--{item.label}--</option>
                        {#each toArray(item.data) as data}
                          <option value={data}>{getWrittenName(data, item?.dataObject)}</option>
                        {/each}
                      </select>
                    </div>
                  {/if}
                {:else}
                  <div class="chatwith-button-label">
                    {item.label}
                  </div>
                  <SelectAsButtons {item} {selectOption} {unselectOption} currency={data?.currency} />
                  <input id={item.id} bind:value={item.val} type="hidden" />
                {/if}
              </div>
            {:else if item.type == "selectAndPrice"}
              <div class="form-element">
                {#if !item.showAsButton && !item.showAsTable}
                  {#if item.usePredictiveText}
                    <SearchableSelect
                      id={item.id}
                      {item}
                      bind:selected={item.val}
                      options={toArray(item.data)}
                      placeholder={item.label}
                      showLabel={false}
                      label={item.label}
                      required={item.required}
                      on:change={(evt) => handleBlur(evt, i)}
                      isError={item.isError}
                      currency={data?.currency}
                    />
                  {:else}
                    <div class="chatwith-select">
                      <!-- svelte-ignore a11y-no-onchange -->
                      <select id={item.id} bind:value={item.val} class={item.isError ? "error-border" : ""} on:change={(evt) => handleBlur(evt, i)} on:focus={() => emitFieldClickEvent(item)}>
                        <option value="">--{item.label}--</option>
                        {#each toArray(item.data) as itemData}
                          <option value={itemData}>{getWrittenName(itemData, item?.dataObject, item?.showPrices, data?.currency)}</option>
                        {/each}
                      </select>
                    </div>
                  {/if}
                {:else}
                  <div class="chatwith-button-label">
                    {item.label}
                  </div>
                  <div class="chatwith-button-options" class:buttons-as-table={item.showAsTable}>
                    {#each toArray(item.data) as itemData}
                      <button
                        type="button"
                        class="chatwith-option-button {item.val == itemData ? 'selected' : ''}"
                        on:click={(e) => {
                          emitFieldClickEvent(item);
                          if (item.val === itemData) {
                            item.val = "";
                            unselectOption(itemData, item, e.target);
                          } else {
                            item.val = itemData;
                            selectOption(itemData, item, e.target);
                          }
                        }}
                      >
                        <div class="chatwith-option-button-text">
                          <span class="chatwith-option-button-name"
                            >{splitNameAndPrice(getWrittenName(itemData, item?.dataObject, item?.showPrices, data?.currency)).name}</span
                          >
                          {#if item?.showPrices}
                            <small class="chatwith-option-button-price"
                              >({splitNameAndPrice(getWrittenName(itemData, item?.dataObject, item?.showPrices, data?.currency)).price})</small
                            >
                          {/if}
                        </div>
                      </button>
                    {/each}
                  </div>
                  <input id={item.id} bind:value={item.val} type="hidden" />
                {/if}
                {#if item.canMultiply}
                  <div class="chatwith-multiply-input" style="margin-top: 10px">
                    <div class="chatwith-input-label">{data.translateAmounts || translations.amount[currentLang] || "Amount"}:</div>
                    <input
                      id={`amount-${item.id}`}
                      type="number"
                      min={item.minAmount ?? 0}
                      max={item.maxAmount}
                      bind:value={item.amount}
                      placeholder={data.translateAmounts || translations.enterAmount[currentLang] || "Enter amount"}
                      on:change={(evt) => handleBlur(evt, i)}
                    />
                  </div>
                {/if}
              </div>
            {:else if item.type == "checkbox"}
              <div class="form-element">
                <div>
                  <label>
                    <input id={item.id} value={false} bind:checked={item.val} on:change={(evt) => handleBlur(evt, i)} on:focus={() => emitFieldClickEvent(item)} type="checkbox" />
                    <p style="font-size: 12px">
                      {item.label}
                      {item.showPrice && item.price && item.price > 0 ? `(${item.price} ${data?.currency})` : ""}
                    </p>
                  </label>
                </div>
              </div>
            {:else if item.type == "hidden2"}
              <div class="form-element">
                <span style="display: none">{item.label}</span>
                <input id={item.id} bind:value={item.value} type="hidden" />
              </div>
            {:else if item.type == "hidden"}
              <div class="form-element">
                <span style="display: none">{item.label}</span>
                <input id={item.id} bind:value={item.value} type="hidden" />
              </div>
            {:else if item.type == "metaTag"}
              <div class="form-element">
                <span style="display: none">{item.label}</span>
                <input id={item.id} bind:value={item.val} type="hidden" />
              </div>
            {:else if item.type == "tel"}
              <div class="form-element">
                <TelField
                  {data}
                  bind:value={item.val}
                  bind:telNum={item.telNum}
                  bind:telCode={item.telCode}
                  placeholder={`${item.label}${item.required ? " *" : ""}`}
                  isError={item.isError}
                  autocomplete="tel-national"
                  on:message={(evt) => handleBlur(evt, i)}
                />
                <input id={item.id} bind:value={item.val} type="hidden" />
              </div>
            {:else if item.type == "zipcode"}
              <div class="form-element">
                <input
                  id={item.id}
                  bind:value={item.val}
                  type="text"
                  class={item.isError ? "error-border" : ""}
                  placeholder={`${item.label}${item.required ? "*" : ""}`}
                  on:keypress={handleKeyPress}
                  on:keyup={(evt) => handleBlur(evt, i)}
                  on:focus={() => emitFieldClickEvent(item)}
                />
              </div>
            {:else if item.type == "gender"}
              <div class="form-element">
                <div class="chatwith-radio-buttons-label">
                  {item.label}
                </div>
                <div class="chatwith-radio-buttons-container">
                  <label>
                    <input
                      class="chatwith-radio-button"
                      type="radio"
                      name="gender-{i}"
                      bind:group={item.val}
                      value="M"
                      on:change={(evt) => handleBlur(evt, i)}
                      on:focus={() => emitFieldClickEvent(item)}
                    />
                    {translations.male[currentLang]}
                  </label>
                  <label>
                    <input
                      class="chatwith-radio-button"
                      type="radio"
                      name="gender-{i}"
                      bind:group={item.val}
                      value="F"
                      on:change={(evt) => handleBlur(evt, i)}
                      on:focus={() => emitFieldClickEvent(item)}
                    />
                    {translations.female[currentLang]}
                  </label>
                  <label>
                    <input
                      class="chatwith-radio-button"
                      type="radio"
                      name="gender-{i}"
                      bind:group={item.val}
                      value="Other"
                      on:change={(evt) => handleBlur(evt, i)}
                      on:focus={() => emitFieldClickEvent(item)}
                    />
                    {translations.other_gender[currentLang]}
                  </label>
                </div>
                <input id={item.id} bind:value={item.val} type="hidden" />
              </div>
            {:else if item.type === "selectBooking"}
              <div class="form-element">
                <div class="chatwith-freebooking">
                  <!-- Select and Price -->
                  <div class="chatwith-select">
                    <!-- svelte-ignore a11y-no-onchange -->
                    <select
                      id={item.id}
                      bind:value={item.selectVal}
                      class={item.isError ? "error-border" : ""}
                      on:change={(evt) => handleBlur(evt, i)}
                      on:focus={() => emitFieldClickEvent(item)}
                    >
                      <option value="">--{item.label}--</option>
                      {#each toArray(item.data) as itemData}
                        <option value={itemData}>{getWrittenName(itemData, item?.dataObject, item?.showPrices, data?.currency)}</option>
                      {/each}
                    </select>
                  </div>

                  <!-- Date input -->
                  <div class="form-element" style={item.displayDateSelect ? "" : "display: none;"}>
                    <input
                      bind:this={inputElements[i]}
                      placeholder={translations.startDate[currentLang]}
                      class="form-element-input {item.isError ? 'error-border' : ''}"
                      type="text"
                    />
                  </div>
                </div>
              </div>
            {:else if item.type === "selectBookingFullDay"}
              <div class="form-element">
                <div class="chatwith-freebooking">
                  <!-- Date range input before if checkCategoriesByDate -->
                  {#if item.useCheckAvailability && item.checkCategoriesByDate}
                    <div class="form-element">
                      <div class="chatwith-input-label">{data.translateDateRange || translations.dateRange[currentLang] || "Date Range"}</div>
                      <input
                        bind:this={inputElements[i]}
                        placeholder={data.translateDateRange || translations.dateRange[currentLang] || "Date Range"}
                        class="form-element-input {item.isError ? 'error-border' : ''}"
                        type="text"
                      />
                    </div>
                  {/if}

                  <!-- Select option -->
                  {#if (item.startDateVal && item.endDateVal) || !item.useCheckAvailability || !item.checkCategoriesByDate}
                    <div class="chatwith-select form-element">
                      <!-- svelte-ignore a11y-no-onchange -->
                      <select
                        id={item.id}
                        bind:value={item.selectVal}
                        class={item.isError ? "error-border" : ""}
                        on:change={(evt) => handleBlur(evt, i)}
                        on:focus={() => emitFieldClickEvent(item)}
                      >
                        <option value="">--{item.label}--</option>
                        {#each enabledCategories as itemData}
                          <option value={itemData}>{getWrittenName(itemData, item?.dataObject, item?.showPrices, data?.currency)}</option>
                        {/each}
                      </select>
                    </div>
                  {/if}

                  <!-- Date range input after if !checkCategoriesByDate -->
                  {#if !item.checkCategoriesByDate || !item.useCheckAvailability}
                    <div class="form-element">
                      <div class="chatwith-input-label">{data.translateDateRange || translations.dateRange[currentLang]}</div>
                      <input
                        bind:this={inputElements[i]}
                        placeholder={data.translateDateRange || translations.dateRange[currentLang]}
                        class="form-element-input {item.isError ? 'error-border' : ''}"
                        type="text"
                      />
                    </div>
                  {/if}
                </div>
              </div>
            {:else if item.type === "selectBookingAdvanced"}
              <div class="form-element">
                {#if !item.showAsButton && !item.showAsTable}
                  <div class="chatwith-select">
                    <!-- svelte-ignore a11y-no-onchange -->
                    <select
                      id={item.id}
                      bind:value={item.selectVal}
                      class={item.isError ? "error-border" : ""}
                      on:change={(evt) => handleBlur(evt, i)}
                      on:focus={() => emitFieldClickEvent(item)}
                    >
                      <option value="">--{item.label}--</option>
                      {#each toArray(item.data) as option}
                        <option value={option}>
                          {getWrittenName(option, item?.dataObject, item?.showPrices, data?.currency, item?.showDurations)}
                        </option>
                      {/each}
                    </select>
                  </div>
                {:else}
                  <div class="chatwith-button-label">
                    {item.label}
                  </div>
                  <SelectAsButtons {item} {selectOption} {unselectOption} currency={data?.currency} />
                {/if}
                {#if item.canMultiply}
                  <div class="chatwith-multiply-input" style="margin-top: 10px">
                    <div class="chatwith-input-label">{data.translateAmounts || translations.amount[currentLang] || "Amount"}:</div>
                    <input
                      id={`amount-${item.id}`}
                      type="number"
                      min={item.minAmount ?? 0}
                      max={item.maxAmount}
                      bind:value={item.amount}
                      placeholder={data.translateAmounts || translations.enterAmount[currentLang] || "Enter amount"}
                      on:change={(evt) => handleBlur(evt, i)}
                    />
                  </div>
                {/if}
              </div>
            {:else if item.type == "email"}
              <div class="form-element">
                <input
                  id={item.id}
                  bind:value={item.val}
                  type="email"
                  autocomplete="email"
                  class={item.isError ? "error-border" : ""}
                  placeholder={`${item.label}${item.required ? " *" : ""}`}
                  on:keypress={handleKeyPress}
                  on:keyup={(evt) => handleBlur(evt, i)}
                  on:focus={() => emitFieldClickEvent(item)}
                />
              </div>
            {:else if item.type == "freetext" && item.hval}
              <div style="font-size: 13px !important;" class="form-element">
                <span class="cw-freetext-inline">{@html replaceURLsWithLinks(interpolatePageVariables(item.hval))}</span>
                {item.showPrice && item.price && item.price > 0 ? `(${item.price} ${data?.currency})` : ""}
              </div>
            {/if}
            {#if item.type !== "step" && !filtered[i] && !(item.onlyAdmins && !data.showAdminFields)}
              <FormValidate
                bind:value={errorList}
                bind:this={formValidateList[i]}
                on:error={(val) => {
                  item.isError = val.detail;
                }}
                {item}
                {data}
                index={i}
                allItems={formitems.items}
              />
            {/if}
            {#if item.type == "checkbox" && item.legalUrl}
              <div class="checkbox-link">
                {#if isBigperson && item.legalCanUseLocalModal && cookieModalExist}
                  {@html `<a style="font-size: 12px" target="_blank" onClick="return modalPrivacityTermsCookies('privacityPopup');">${
                    item.legalUrlText ?? "Click here to see the Privacy Policy"
                  }</a
                >`}
                {:else}
                  <a style="font-size: 12px" target="_blank" href={item.legalUrl}>{item.legalUrlText ?? "Click here to see the Privacy Policy"}</a>
                {/if}
              </div>
            {/if}
          </div>
        {/each}
      {/if}
      {#if showBookingsAdvancedScreen}
        <BookingsAdvancedCalendar
          on:bookingSelected={handleBookingSelected}
          on:back={() => (showBookingsAdvancedScreen = false)}
          {selectedBookingAdvancedCategoryIds}
          requiredError={bookingsAdvancedRequiredError}
        />
      {/if}
    </div>
  </div>
</div>
<div class="chatwith-footer">
  <div class="cw-total-info">
    {#if formitems.showTotalDuration}
      <div class="cw-total-duration">
        <span>{translations.totalDuration[currentLang]}: <b>{totalDuration}</b></span>
      </div>
    {/if}
    {#if formitems.showTotal}
      <div class="cw-total-price">
        <span>{translations.totalPrice[currentLang]}: <b>{totalPrice.toFixed(2)} {data.currency}</b></span>
      </div>
    {/if}
  </div>
  <div class:chatwith-step-navigation={showStepNavigation}>
  {#if showStepNavigation}
    <button
      type="button"
      class="chatwith-step-arrow"
      disabled={!hasPreviousStep || isLoading || isValidatingEmail}
      aria-label={translations.wizardPrevious[currentLang] || translations.wizardPrevious.en}
      on:click={() => { currentStep = visibleSteps[visibleSteps.indexOf(currentStep) - 1]; }}
    ><svg aria-hidden="true" viewBox="0 0 16 24"><path d="M13 2 L3 12 L13 22 Z" /></svg></button>
  {/if}
  <div class:chatwith-step-forward={showStepNavigation}>
  {#if !showBooking && !showBookingsAdvancedScreen && hasNextStep}
    {#if isValidatingEmail}<div class="chatwith-validating-email">{translations.emailValidatingText[currentLang]}</div>{/if}
    <button
      type="button"
      class="chatwith-step-arrow chatwith-step-next"
      disabled={isLoading || isValidatingEmail}
      aria-label={translations.wizardNext[currentLang] || translations.wizardNext.en}
      on:click={() => sendtocallme()}
    ><svg aria-hidden="true" viewBox="0 0 16 24"><path d="M3 2 L13 12 L3 22 Z" /></svg></button>
  {:else if formitems.buyLinks && formitems.buyLinks.length > 0 && !showBooking}
    {#each formitems.buyLinks as item, i}
      <Button
        id={"chatwith-buy-button" + i}
        on:click={() => sendtocallme(item.link)}
        buttonText={item.buttontext}
        showIcon={true}
        iconUrl={data.whatsappIconUrl}
        spanClassName={item.buttontext.length >= 25 ? "chatwith-button-long-span" : ""}
      />
    {/each}
  {:else}
    {#if isValidatingEmail}
      <div class="chatwith-validating-email">{translations.emailValidatingText[currentLang]}</div>
    {:else if isLoading}
      <Spinner />
    {/if}
    {#if data.editModeStatId && data.showAdminFields}
      <label class="cw-resend-email">
        <input name="reSendEmail" type="checkbox" bind:checked={reSendEmail} />
        <span>{translations.reSendEmail[currentLang] ?? translations.reSendEmail.en}</span>
      </label>
      <label class="cw-resend-email">
        <input name="reSendWhatsapp" type="checkbox" bind:checked={reSendWhatsapp} />
        <span>{translations.reSendWhatsapp[currentLang] ?? translations.reSendWhatsapp.en}</span>
      </label>
    {/if}
    <Button
      on:click={() => sendtocallme(null)}
      buttonText={showBooking ? formitems.buttontext ?? "Book now" : formitems.buttontext}
      showIcon={true}
      iconUrl={data.whatsappIconUrl}
      spanClassName={formitems.buttontext.length >= 25 ? "chatwith-button-long-span" : ""}
      className={isSent ? "chatwith-button-disabled" : ""}
    >
      {#if isSent && !data.sellLeads}
        <Toast
          message={sendMessage}
          visible={isSent}
          type="success"
          manualClose={showCloseConversationToast}
          on:close-toast={() => {
            isSent = false;
            showCloseConversationToast = false;
          }}
        />
      {/if}
    </Button>
  {/if}
  </div>
  </div>
  {#if data.showBrandInWidget}
    <div class="chatwith-brand" style="font-size: 13px; font-weight:600; margin-top: 10px; color: #666; text-align: center">
      {#if data.brandNameUrl}
        <span><a style="color: blueviolet; font-size: 13px;" target="_blank" href={addHttpsToUrl(data.brandNameUrl)}>{data.brandName}</a></span>
      {:else}
        <span style="font-size: 13px;">{data.brandName}</span>
      {/if}
    </div>
  {/if}
</div>
{#if isSent && data.sellLeads}
  <Toast
    message={sendMessage}
    visible={isSent}
    type="success"
    manualClose={showCloseConversationToast}
    sellLeadsWidget={data.sellLeads}
    on:close-toast={() => {
      isSent = false;
      showCloseConversationToast = false;
    }}
  />
{/if}

<style>
  .chatwith-step-navigation {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 16px;
  }

  .chatwith-step-forward {
    margin-left: auto;
    min-width: 0;
    max-width: calc(100% - 96px);
  }

  .chatwith-step-forward :global(.chatwith-button) {
    margin: 0;
  }

  .chatwith-step-arrow {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-shrink: 0;
    width: 80px;
    height: 36px;
    padding: 4px 8px;
    border: 1px solid var(--color, #25d366);
    border-radius: 6px;
    background: #eee;
    color: var(--color, #25d366);
    cursor: pointer;
  }

  .chatwith-step-next { justify-content: flex-end; }
  .chatwith-step-arrow:disabled {
    border-color: #ccc;
    color: #b5b5b5;
    cursor: default;
  }
  .chatwith-step-arrow:focus-visible {
    outline: 2px solid var(--color, #25d366);
    outline-offset: 3px;
  }
  .chatwith-step-arrow svg { width: 16px; height: 24px; fill: currentColor; }

  .chatwith-validating-email {
    font-size: 12px;
    color: #666;
    text-align: center;
    padding: 4px 0;
  }

  .cw-resend-email {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0 0 10px;
    font-size: 12px;
    cursor: pointer;
  }

  .cw-resend-email input {
    margin: 0;
  }

  .existing-file-preview {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px 0;
  }

  .file-preview-img {
    max-width: 100%;
    max-height: 200px;
    border-radius: 4px;
    object-fit: contain;
  }

  .file-preview-actions {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .file-preview-actions a {
    font-size: 13px;
    color: #007bff;
    text-decoration: underline;
  }

  .replace-file-btn {
    font-size: 12px;
    padding: 3px 8px;
    cursor: pointer;
    background: none;
    border: 1px solid #aaa;
    border-radius: 4px;
    color: #555;
  }

  .replace-file-btn:hover {
    background: #f0f0f0;
  }

  .admin-only-field {
    position: relative;
    padding-top: 20px;
  }

  .admin-only-badge {
    position: absolute;
    top: 20px;
    right: 0;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #c2410c;
    background: #fff7ed;
    border: 1px solid #fdba74;
    border-radius: 4px;
    padding: 1px 6px;
    pointer-events: none;
  }

  .admin-only-field input,
  .admin-only-field select,
  .admin-only-field textarea {
    border: 1px solid #fdba74 !important;
  }
</style>
